export default "__VITE_ASSET__CYhWi9B2__"